import classNames from 'classnames';
import Card from './Card';
import styles from './BusinessSectionBannersWithIcon.module.scss';
import SectionTitle from '../SectionTitle/SectionTitle';

const BusinessSectionBannersWithIcon = ({ data, className }) => {
  const renderCardItem = (item, index) => {
    return <Card data={item} key={index} point={index + 1} />;
  };

  return (
    <section
      className={classNames([styles['card-block'], className])}
      data-testId='section'
      itemScope
      itemType='https://schema.org/Article'
    >
      {!!data?.title && (
        <SectionTitle
          titleModify='title--large'
          className={styles['card-block__title']}
        >
          {data.title}
        </SectionTitle>
      )}
      <div className={classNames([styles['card-block__inner']])}>
        {data?.sections?.map(renderCardItem)}
      </div>
    </section>
  );
};

export default BusinessSectionBannersWithIcon;
